import { render, staticRenderFns } from "./ProductCartItems.vue?vue&type=template&id=5808ed01"
import script from "./ProductCartItems.vue?vue&type=script&lang=js"
export * from "./ProductCartItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports